export default __webpack_public_path__ + "media/zurb/img/events/wired/rebuilding/rebuilding-photos-da23ea9e2b3d0c42aa943543c5b947c6.png";